<template>
    <form
        :class="[
            'styled-form',
            'styled-form--white-box',
            {'is-loading': isLoading}
        ]"
        @submit.prevent="onSubmit"
    >

        <div v-if="isLoading" class="styled-form__overlay">
            <div class="preloader"></div>
        </div>

        <global-message v-if="errors.global" :value="errors.global"></global-message>

        <div class="styled-form__header">
            <h2 class="styled-form__title">Reset password</h2>
            <h3 class="styled-form__subtitle">Please enter the email address you provided during the sign up to receive a password reset code via email. Password reset is not applicable for accounts created using Google.</h3>
        </div>

        <div class="styled-form__corset">
            <form-input
                v-model="data.email"
                name="email"
                label="Email address"
                :error="errors.email"
                class="to-lower-case"
            ></form-input>
        </div>

        <div class="text--center">
            <router-link
                    class="btn btn--secondary"
                    :disabled="isLoading"
                    :to="{name: 'login'}"
            >Cancel</router-link>
            <button class="btn" :disabled="isLoading">Continue</button>
        </div>
    </form>
</template>

<script>
    import GlobalMessage from '../messages/GlobalMessage.vue';
    import FormInput from '../formFields/FormInput.vue';
    import isEmail from '../../helpers/isEmail';

    export default {
        components: {
            GlobalMessage,
            FormInput
        },
        props: {
            submit: {
                type: Function,
                required: true
            },
            email: String
        },
        data() {
            return {
                isLoading: false,
                data: {
                    email: ''
                },
                errors: {}
            }
        },
        created() {
            this.validateProps();
        },
        methods: {
            validateProps() {
                if (isEmail(this.email)) {
					let emailProp = this.email;
					this.data.email = emailProp.toLowerCase();
                }
            },
            onSubmit() {
                this.errors = this.validate(this.data);

                if (Object.keys(this.errors).length === 0) {
                    this.data.email = this.data.email.toLowerCase();
                    this.isLoading = true;
                    this.submit(this.data).catch(errors => {
                        this.isLoading = false;
                        this.errors = errors;
                    });
                }
            },
            validate(data) {
                const errors = {};

                if (!data.email.length) {
                    errors.email = 'This field is required';
                } else if (!isEmail(data.email)) {
                    errors.email = 'Invalid email';
                }

                return errors;
            }

        }
    };
</script>
